<template>
  <div class="my_software chinese_container">
    <myHeader />
    <div class="bg">
      <h1 class="ProductTitle">软件订阅</h1>
      <div class="card-container">
        <!-- :style="{
            border: card.isSelected ? '4px solid #2a82e4' : '0px solid #2a82e4',
            boxShadow: card.isSelected ? '5px 5px 20px #007bff' : 'none',
          }" -->
        <div
          v-for="(card, index) in cards"
          :key="index"
          class="card"
          @click="selectCard(index)"
          :class="{ cardActive: card.isSelected }"
        >
          <div class="card-icon" :style="{ backgroundColor: card.bgColor }">
            {{ card.title }}
          </div>
          <div class="card-price">
            <span>{{ card.price }}</span>
            <span></span>
          </div>
          <!-- <input type="number" class="num" v-model="card.num"> -->
          <!-- <div class="card-subtext">{{ card.subtext }}</div> -->
          <!-- <button class="subscribe-btn" :class="card.btnClass" @click="MembershipSubscription(index, card.num)">立即订阅</button> -->
        </div>
      </div>
      <div class="feedback-container">
        <p>请填入最让您满意的工作人员姓名，这将会对TA产生正向激励，</p>
        <p>希望这样能给您带来更好的学习与使用体验。</p>
        <div class="input-group">
          <p>
            姓名: &nbsp;<input
              type="text"
              v-model="workName"
              placeholder="工作人员姓名 (选填)"
            />
          </p>
          <p>
            数量: &nbsp;<input
              type="text"
              v-model="selectedNum"
              placeholder="请输入订购数量"
              @input="validateInput"
            />
          </p>
          <button
            type="text"
            class="button_bor"
            :disabled="btnDisabled"
            @click="handleSubscribe"
          >
            立即订阅
          </button>
        </div>
      </div>
    </div>
    <div class="bg1">
      <div>
        <h1 class="headtext wow fadeInUp ProductTitle">
          登录您的<span class="colorb">hecoos会员账号</span><br />可体验到
        </h1>
      </div>
      <div class="slider wow fadeInUp">
        <div
          class="slider-wrapper"
          :style="{
            transform: `translateX(-${(currentIndex * 150) / slides.length}%)`,
          }"
        >
          <div
            v-for="(slide, index) in slides"
            :key="index"
            class="slide"
            :class="{ hiddenImg: currentIndex == 0 && index == 3 }"
          >
            <img :src="slide.image" alt="slide" />
            <p>{{ slide.desc }}</p>
          </div>
        </div>
      </div>
      <div class="parents">
        <button
          class="arrow-button"
          @click="prevSlide"
          :class="{ disableBtn: currentIndex == 0 }"
        >
          <i class="el-icon-arrow-left"></i>
        </button>
        <button
          class="arrow-button"
          @click="nextSlide"
          :class="{ disableBtn: currentIndex == slides.length - 2 }"
        >
          <i class="el-icon-arrow-right"></i>
        </button>
      </div>
    </div>
    <myFooter />
    <BackToTop></BackToTop>
  </div>
</template>

<script>
import myHeader from "@/components/pc/myHeader";
import myFooter from "@/components/pc/myFooter";
import BackToTop from "@/components/pc/BackToTop";
import { VipSubscribe } from "@/api/api";
import { Message } from "element-ui";

export default {
  data() {
    return {
      btnDisabled: false,
      workName: "",
      orderType: 3, //存储对应的 周月年
      staffName: "", //存储姓名
      selectedNum: 1, // 新增变量，用于存储选中卡片的数量
      cards: [
        {
          title: "周",
          price: "¥98.00",
          subtext: "Per week",
          btnClass: "one",
          bgColor: "#848A95 ",
          isSelected: false,
          orderType: 3,
          num: 1,
        },
        {
          title: "月",
          price: "¥198.00",
          subtext: "Per month",
          btnClass: "active",
          bgColor: "#147CF5",
          isSelected: false,
          orderType: 1,
          num: 1,
        },
        {
          title: "年",
          price: "¥1998.00",
          subtext: "Per year",
          btnClass: "dark",
          bgColor: "#0B162B",
          orderType: 2,
          isSelected: false,
          num: 1,
        },
      ],
      // carouselList: [
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      //   {
      //     imageSrc: require("@/asset/SoftwareSubscriptions/bg.png"),
      //     description: "三维场景预览、投影仿真、灯光效果编辑与导播设计",
      //   },
      // ],
      currentIndex: 0,
      slides: [
        {
          image:
            "https://download.hecoos.com/enlightv/2025-17/2047ae4d53f30580adec9c4a7719b9ad.png",
          desc: "三维场景预演、投影仿真、灯光效果编辑与导播设计",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-17/a25b47a39e2b1bebeab4e93ea3fa85ae.png",
          desc: "2*2K测试信号输出(带水印) 外部设备控制(间歇性中断)",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-17/9c609c133d5ff2e733e08934ef8167c5.png",
          desc: "节目与控制指令编辑 项目现场调试",
        },
        {
          image:
            "https://download.hecoos.com/enlightv/2025-35/02a5e47e63883b0428b059fb2ae7357b.jpg",
          desc: "作为项目测试端应用可脱离hecoos服务器使用",
        },
      ],
    };
  },
  created() {
    // this.MembershipSubscription()
    if (localStorage.getItem("orderMsg")) {
      const msg = JSON.parse(localStorage.getItem("orderMsg"));
      // 重新选中年月日
      // if (msg.orderType === 3) {
      //   this.cards[0].isSelected = true;
      //   this.cards[0].num = msg.num;
      // } else if (msg.orderType === 1) {
      //   this.cards[1].isSelected = true;
      //   this.cards[1].num = msg.num;
      // } else if (index === 2) {
      //   this.cards[2].isSelected = true;
      //   this.cards[2].num = msg.num;
      // }
      console.log(msg);
      this.cards.forEach((item, index) => {
        if (item.orderType == msg.orderType) {
          this.orderType = msg.orderType;
          item.isSelected = true;
          item.num = msg.num;
        } else {
          item.isSelected = false;
        }
      });
      // 重新赋值之前选择的数量
      this.selectedNum = msg.num;
      localStorage.removeItem("orderMsg");
    }
    if (this.$route.query.orderType) {
      let orderType = this.$route.query.orderType;
      this.cards.forEach((item, index) => {
        if (item.orderType == orderType) {
          this.orderType = orderType;
          item.isSelected = true;
        } else {
          item.isSelected = false;
        }
      });
    }
  },
  watch: {
    workName(newValue) {
      console.log(newValue, "newValue");
    },
  },
  components: { myHeader, myFooter, BackToTop },
  methods: {
    validateInput() {
      // 移除所有非数字字符
      let value = this.selectedNum.toString().replace(/[^0-9]/g, "");

      // 转换为数字
      let num = Number(value);

      // 处理空值情况
      if (value === "") {
        this.selectedNum = "";
        return;
      }

      // 限制范围
      if (num < 1) {
        num = 1;
      } else if (num > 99) {
        num = 99;
      }

      this.selectedNum = num;
    },
    changeStaffName(tt) {
      console.log(tt);
    },
    // 选中对应的价格
    selectCard(index) {
      this.cards.forEach((card, i) => {
        card.isSelected = i === index;
      });
      // 存储对应的数字 1, 2, 3
      if (index === 0) {
        this.orderType = 3;
      } else if (index === 1) {
        this.orderType = 1;
      } else if (index === 2) {
        this.orderType = 2;
      }
      console.log(this.orderType);
      this.selectedNum = this.cards[index].num; // 更新选中卡片的数量
    },

    prevSlide() {
      if (this.currentIndex != 0) {
        this.currentIndex =
          (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      }
    },
    nextSlide() {
      if (this.currentIndex != this.slides.length - 2) {
        this.currentIndex = (this.currentIndex + 1) % this.slides.length;
      }
    },
    handleSubscribe() {
      const orderMsg = {
        orderType: this.orderType,
        num: this.selectedNum,
      };
      if (!this.orderType) {
        Message.error("请先选择订阅类型");
        return;
      }
      if (this.selectedNum <= 0) {
        Message.error("订阅数量必须大于 0");
        return;
      }
      if (!localStorage.getItem("token")) {
        localStorage.setItem("orderMsg", JSON.stringify(orderMsg));
        Message.error("请先登录");
        setTimeout(() => {
          this.$router.push("/login");
        }, 800);
        return;
      }

      const type = this.orderType;
      const num = this.selectedNum;
      this.MembershipSubscription(type, num);
    },

    MembershipSubscription(type, num) {
      this.btnDisabled = true;
      let postData = {
        orderType: type,
        num: num,
        // staffName: this.staffName  //姓名不传
      };

      // console.log(postData);

      VipSubscribe(postData).then((res) => {
        if (res.code === 200) {
          this.btnDisabled = false;
          // 创建一个新的 div 元素来插入表单
          const formDiv = document.createElement("div");
          formDiv.innerHTML = res.data.buyFormHtml;
          console.log(res.data);
          document.body.appendChild(formDiv);
          // 自动提交表单
          const form = formDiv.querySelector("form");
          if (form) {
            form.submit();
          }
        } else {
          this.btnDisabled = false;
          console.error("订阅失败:", res.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/software.scss";
@import "@/styles/optimize_adaptation.scss";
.disableBtn {
  opacity: 0.4;
  cursor: default !important;
}
.hiddenImg {
  opacity: 0;
}
.my_software .disableBtn:hover {
  background-color: #343334;
}
</style>
